<nz-layout class="app-layout">
  <nz-sider
    style="background: white"
    [ngClass]="isCollapsed ? 'menu-sidebar' : 'menu-sidebar mobile-menu-show'"
    nzCollapsible
    nzWidth="256px"
    nzBreakpoint="md"
    [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null"
  >
    <div class="container-fluid d-flex justify-content-between bd-highlight">
      <div class="p-2 bd-highlight">
        <div class="d-flex flex-row">
          <div>
            <a href="#">
              <img src="assets/images/Group 98.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <ul
      nz-menu
      nzTheme="light"
      nzMode="inline"
      [nzInlineCollapsed]="isCollapsed"
    >
      <li
        nz-menu-item
        routerLink="/home/stp-dashboard"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.dashboard.menuStpDashboard
        "
        (click)="nzCollapsed()"
      >
        <span nz-icon nzType="line-chart"></span>
        <span>Dashboard</span>
      </li>
      <li
        nz-menu-item
        routerLink="/home/admins-dashboard"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.dashboard.menuAdminsDashboard
        "
        (click)="nzCollapsed()"
      >
        <span nz-icon nzType="line-chart"></span>
        <span>Dashboard</span>
      </li>
      <li
        nz-menu-item
        routerLink="/home/assessors-dashboard"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.dashboard.menuAssessorsDashboard
        "
        (click)="nzCollapsed()"
      >
        <span nz-icon nzType="line-chart"></span>
        <span>Dashboard</span>
      </li>
      <li nz-menu-item routerLink="/">
        <span nz-icon nzType="home"></span>
        <span>Home</span>
      </li>

      <li
        nz-submenu
        nzClose
        nzTitle="Authorization"
        nzIcon="lock"
        [appRequiredPermission]="
          applicationPermissions.authorization.role.menuPermission +
          ',' +
          applicationPermissions.authorization.projectModule.menuPermission +
          ',' +
          applicationPermissions.authorization.permission.menuPermission +
          ',' +
          applicationPermissions.authorization.role.rolePermission
            .menuPermission +
          ',' +
          applicationPermissions.authorization.featurePermission
            .menuFeaturePermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.role.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/role"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Role</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.projectModule.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/project-module"
              ><i nz-icon nzType="project" nzTheme="outline"></i>Project
              Module</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.permission.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/permission"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Permission</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.role.rolePermission
                .menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/role/permission"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Role Permission</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.featurePermission
                .menuFeaturePermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/feature-permission"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Feature
              Permission</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.log
                .authenticationLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authentication/authorization-activity-log"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Authentication
              Log</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.authorization.log
                .aclActivityLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/authorization/acl-activity-log"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>ACL Activity
              Log</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzTitle="User"
        nzIcon="user"
        [appRequiredPermission]="
          applicationPermissions.user.userList.menuPermission +
          ',' +
          applicationPermissions.user.userList.menuCreateUserPermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.user.userList.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/user"
              ><i nz-icon nzType="user" nzTheme="outline"></i>User List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.user.userList.menuCreateUserPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/user/create"
              ><i nz-icon nzType="user" nzTheme="outline"></i>Create User</a
            >
          </li>


          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.user.userList.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/user/loglist"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Activity Log</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.user.log.aclUserActivityLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/user/acl-user-activity-log"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>User Activity
              Log</a
            >
          </li>



          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.programAndProjects.projectMakerList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/program-project/project-maker-list"
              ><i nz-icon nzType="user" nzTheme="outline"></i>Project Maker List</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzIcon="appstore"
        nzTheme="outline"
        nzClose
        nzTitle="STP Application"
        [appRequiredPermission]="
          applicationPermissions.stpRegistration.stpApplication.menuPermission + ',' +
          applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpRenewalApplicationList + ',' +
          applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpReapplyApplicationList
        "

      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/stp-applications"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpReapplyApplicationListAdmin
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/stp-renewal-application-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Renewal Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpRenewalApplicationListAdmin
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/stp-reapply-application-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Reapply Application List</a
            >
          </li>
          <!-- assigned NSDA officer: only the applications whose inspection is assigned to them -->
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpRenewalApplicationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/assigned-stp-renewal-application-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Assigned Renewal Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuAssignedStpReapplyApplicationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/assigned-stp-reapply-application-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Assigned Reapply Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpRenewReapplyApplication.menuStpRenewReapplyArchiveListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/stp-renew-reapply-archive-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Archive List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/stp-activity-log"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >STP Activity Log</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuPreviousStpApplicationListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/previous-stp-applications-admin"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Previous Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuStpApplicationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/application-list-stp"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Application List</a
            >
          </li>
          <!-- STP user: its renewal / reapply application is in the Application List above; archived versions below -->
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuStpApplicationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/application-list-stp/archive"
              ><i nz-icon nzType="inbox" nzTheme="outline"></i
              >Archive List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuStpApplicationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/sent-for-corrections"
              ><i nz-icon nzType="send" nzTheme="outline"></i>Correction
              Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication
                .menuCorrectionRequestList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/correction-request-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Correction
              Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplication.menuSetup
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/setup"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Setup</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="snippets"
        nzTheme="outline"
        nzTitle="TAM"
        [appRequiredPermission]="
          applicationPermissions.tam.tam.menuListPermission +
          ',' +
          applicationPermissions.tam.archive.menuListPermission +
          ',' +
          applicationPermissions.tam.occupation.menuListPermission +
          ',' +
          applicationPermissions.tam.tam.menuCreatePermission +
          ',' +
          applicationPermissions.tam.occupation.menuCreatePermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.tam.menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/training-and-assessment-materials/tam-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>TAM
              List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.archive.menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/training-and-assessment-materials/tam-archive-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>TAM
              Archive List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.occupation.menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/training-and-assessment-materials/occupation-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Occupation
              List
            </a>
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.tam.menuCreatePermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/training-and-assessment-materials/tam-create"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Add TAM</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.occupation.menuCreatePermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/training-and-assessment-materials/occupation-create"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Add Occupation
            </a>
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.occupation.menuCreatePermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/training-and-assessment-materials/loglist"
              ><i nz-icon nzType="form" nzTheme="outline"></i>TAM Log
            </a>
          </li>

          <!--          cblm menu -->
          <li
            nz-submenu
            nzClose
            nzIcon="book"
            nzTheme="outline"
            nzTitle="CBLM"
            [appRequiredPermission]="
              applicationPermissions.tam.occupation.menuCreatePermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuGenericCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/generic-competency"
                >
                  <i nz-icon nzType="form" nzTheme="outline"></i> Add Generic
                  Competency
                </a>
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuArchiveGenericCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/cblm-archive-generic-competency"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i> Archived Generic
                  Competency
                </a>
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuSectorCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/sector-competency"
                >
                  <i nz-icon nzType="form" nzTheme="outline"></i> Add Sector
                  Specific Competency
                </a>
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuArchiveSectorCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/cblm-archive-sector-competency"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i> Archived Sector
                  Specific Competency
                </a>
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuOccupationCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/occupation-competency"
                >
                  <i nz-icon nzType="form" nzTheme="outline"></i> Add Occupation
                  Specific Competency
                </a>
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.tam.CBLM.menuArchiveOccupationCompetency
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/training-and-assessment-materials/cblm-archive-occupation-competency"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i> Archived Occupation
                  Specific Competency
                </a>
              </li>
            </ul>
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tam.log.tamActivityLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/training-and-assessment-materials/activity-log-tam"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>TAM Activity Log
            </a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="audit"
        nzTheme="outline"
        nzTitle="Appeal"
        [appRequiredPermission]="
          applicationPermissions.appeal.appeal.menuListPermission +
          ',' +
          applicationPermissions.appeal.appeal.menuListAdminPermission +
          ',' +
          applicationPermissions.appeal.appeal.menuCreatePermission +
          ',' +
          applicationPermissions.appeal.appeal.menuPaymentSetupPermission +
          ',' +
          applicationPermissions.appeal.log.appealActivityLogPermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.appeal.appeal.menuPaymentSetupPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              [routerLink]="['/home/payment/payment-type-list']"
              [queryParams]="{ module: 'APL' }"
              ><i nz-icon nzType="dollar" nzTheme="outline"></i>Appeal Payment
              Setup</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.appeal.appeal.menuCreatePermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/appeal/create"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Create Appeal</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.appeal.appeal.menuListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/appeal/appeal-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Appeal
              List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.appeal.appeal.menuListAdminPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/appeal/appeal-list-admin"
              ><i nz-icon nzType="profile" nzTheme="outline"></i>Appeal List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.appeal.log.appealActivityLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/appeal/appeal-activity-log"
              ><i nz-icon nzType="audit" nzTheme="outline"></i>Appeal Activity
              Log</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzIcon="safety-certificate"
        nzTheme="outline"
        nzClose
        nzTitle="Certificate"
        [appRequiredPermission]="applicationPermissions.tci.menuPermission"
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.tci.tciList
                .menuUploadCertificateListPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/tci/competent-person-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Upload
              Certificate List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="applicationPermissions.tci.menuSendEmail"
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/tci/send-email"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Send
              Email</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzIcon="reconciliation"
        nzTheme="outline"
        nzClose
        nzTitle="Course Accreditation"
        [appRequiredPermission]="
          applicationPermissions.courseAccreditation.courseAccreditation
            .menuApplyForCourseAccreditation +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuAppliedForCourseList +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuNotApprovedOccupationList +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuExpiredOccupationList +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuRenewalApplications +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuReapplyApplications +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuPermission +
          ',' +
          applicationPermissions.courseAccreditation.courseAccreditationList
            .menuNsdaPermission +
          ',' +
          applicationPermissions.settings.inspectionOfficer.menuPermission +
          ',' +
          applicationPermissions.stpOperation.approvedOccupations
            .menuApprovedOccupationList +
          ',' +
          applicationPermissions.stpOperation.rollback.rollbackStatus
            .menuPermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditation
                .menuApplyForCourseAccreditation
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/course-accreditation/course-accreditation"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Apply for Course
              Accreditation</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuNotApprovedOccupationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/course-accreditation/course-accreditation-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Applied
              Course List</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuAppliedForCourseList
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/course-accreditation/preview-re-apply-course-accreditation-list"
            >
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>Not Approved
              Occupaion List</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuRenewalApplications
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/course-accreditation/course-accreditation-admin-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Application List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuReapplyApplications
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/course-accreditation/course-accreditation-renewal-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Renewal Applications</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/course-accreditation/course-accreditation-reapply-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Re-Apply Applications</a
            >
          </li>
          <li
            *ngIf="this.userInfo.tag == 'nsda'"
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuNsdaPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/course-accreditation/course-accreditation-inspector-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Application List NSDA</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.settings.inspectionOfficer.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/inspection-officer-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Inspection
              Officer (ISC)</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.courseAccreditationList
                .menuExpiredOccupationList
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-operations/expired-occupation-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Expired
              Occupation List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpOperation.rollback.rollbackStatus
                .menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/rollback/rollback-status"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Rollback Status</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.courseAccreditation.log
                .stpActivityLogPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-operations/log"
              ><i nz-icon nzType="form" nzTheme="outline"></i>STP Activity
              log</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzIcon="application"
        nzClose
        nzIcon="money-collect"
        nzTitle="Payment"
        [appRequiredPermission]="applicationPermissions.payment.menuPermission"
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.payment.menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/payment/payment-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Payment
              List</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.payment.paymentList.menuGatewayPermission
            "
            (click)="nzCollapsed()"
          >
            <a href="https://admin.ekpay.gov.bd/"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Payment
              Gateway</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzTitle="Profile View"
        nzIcon="profile"
        [appRequiredPermission]="
          applicationPermissions.stpRegistration.stpApplicationView
            .menuEditPermission +
          ',' +
          applicationPermissions.stpRegistration.stpApplicationView
            .menuFullViewPermission +
          ',' +
          applicationPermissions.stpRegistration.stpApplicationView
            .menuStpDownloadCertificate +
          ',' +
          applicationPermissions.stpRegistration.stpApplicationView
            .menuUpdateContactInformation
        "
      >
        <ul>
          <!-- Edit Application removed: the STP edits from the Application List (Edit / Start Application) or from
               Full Application View, and is sent to the form at login while registration is not completed. -->
          <!-- <li
            nz-menu-item
            *ngIf="!isComplete"
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplicationView
                .menuEditPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-registration/dash-board"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Edit
              Application</a
            >
          </li> -->
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplicationView
                .menuFullViewPermission
            "
            (click)="nzCollapsed()"
          >
            <a
              [routerLink]="[
                '/home/stp-registration/stp-application-view/',
                stpMainId
              ]"
            >
              <span nz-icon nzType="profile" nzTheme="outline"></span>Full
              Application View</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplicationView
                .menuStpDownloadCertificate
            "
            (click)="nzCollapsed()"
          >
            <a (click)="showModal()"
              ><span nz-icon nzType="download" nzTheme="outline"></span>Download
              Certificate</a
            >
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.stpRegistration.stpApplicationView
                .menuUpdateContactInformation
            "
            (click)="nzCollapsed()"
          >
            <a
              [routerLink]="[
                '/home/stp-registration/stp-organization-address-update/',
                stpMainId
              ]"
            >
              <span nz-icon nzType="form" nzTheme="outline"></span>Update
              Contact Information</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="translation"
        nzTheme="outline"
        nzTitle="Training Management"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.menuPermission
        "
      >
        <ul>
          <li
            nz-menu-item
            nzClose
            nzIcon="file"
            nzTitle="STP List View"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.stpListAdminView
                .menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-operations/stp-list/stp-list-view">
              <i nz-icon nzType="form" nzTheme="outline"></i>STP List View</a
            >
          </li>

            <li
            nz-menu-item
            nzClose
            nzIcon="file"
            nzTitle="STP List View"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.stpListAdminView
                .menuPermission
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/stp-operations/loglist">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>STP Op. Activity Log</a
            >
          </li>

          <!-- <li nz-submenu nzIcon="application" nzClose nzIcon="file" nzTitle="Approved Occupations"
            [appRequiredPermission]="
             applicationPermissions.stpOperation.approvedOccupations.readApprovedOccupations
            ">
            <ul>
              <li nz-menu-item [appRequiredPermission]="
              applicationPermissions.stpOperation.approvedOccupations.readApprovedOccupations
              ">
                <a routerLink="/home/stp-operations/approved-occupation/approved-occupation-list"><i nz-icon
                    nzType="form" nzTheme="outline"></i>Approved
                  Occupation List
                </a>
              </li>
            </ul>
          </li> -->

          <li>
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.approvedOccupations
                    .menuApprovedOccupationList
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/approved-occupation/approved-occupation-list"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Approved Occupation List
                </a>
              </li>
            </ul>
          </li>

          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="file"
            nzTitle="Project"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.project.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.project.createPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/project/create-project">
                  <i nz-icon nzType="form" nzTheme="outline"></i>Create
                  Project</a
                >
              </li>
            </ul>
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.project.menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/project/project-list">
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Project
                  List</a
                >
              </li>
            </ul>
          </li>

          <li
            nz-submenu
            nzClose
            nzIcon="file"
            nzTitle="Course"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.course.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.course.menuCeatePermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/course/create-course"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Create Course
                </a>
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.course.menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/course/course-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>
                  Course List</a
                >
              </li>
            </ul>
          </li>

          <li
            nz-submenu
            nzClose
            nzIcon="file"
            nzTitle="Batch"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.batch.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.batch.menuCreatePermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/batch/batch-create"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Create
                  Batch</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.batch.menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/batch/batch-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Batch
                  List</a
                >
              </li>
            </ul>
          </li>
          <li
            nz-submenu
            nzClose
            nzIcon="user"
            nzTitle="Trainer"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.trainer.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.trainer
                    .menuCreatePermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/trainer/create-trainer"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Add Trainer</a
                >
              </li>
            </ul>
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.trainer.menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/trainer/trainer-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Trainer List</a
                >
              </li>
            </ul>
          </li>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="user"
            nzTitle="Trainee"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.trainee.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.trainee
                    .menuCreatePermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/trainee/trainee-create"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Add Trainee</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.trainee.menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/trainee/trainee-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>
                  Trainee List</a
                >
              </li>
            </ul>
          </li>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="file"
            nzTitle="RPL-Batch"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.rplCandidate.menuRplCandidate
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplCandidate
                    .menuRegisterRplCandidate
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/rpl/Add-candidate-for-rpl"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Register
                  Candidate</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplCandidate
                    .menuCandidateList
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/rpl/candidateList"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Candidate
                  List</a
                >
              </li>

              <!-- rpl feature v2 -->
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplCandidate
                    .menuAssessmentApply
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/rpl/apply-for-rpl-batch"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Assessment
                  Apply</a
                >
              </li>

              <!-- rpl feature v1 -->
              <!-- <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplCandidate
                    .menuAssessmentApply
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/rpl/apply-for-rpl-batch-assessment"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Assessment
                  Apply</a
                >
              </li> -->
            </ul>
          </li>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="file"
            nzTitle="Assessment"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.asseessmentStp
                .menuAssessmentStp
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.commonForRplRegAssessment
                    .menuAssessmentApplicationList
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/rpl/assessment-application-list-stp"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Application List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.asseessmentStp
                    .menuAssessmentResultStp
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/assessment/assessment-result-stp"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Assessment Result</a
                >
              </li>
            </ul>
          </li>
          <li
            nz-submenu
            nzIcon="split-cells"
            nzClose
            nzIcon="split-cells"
            nzTitle="Re-Assessment"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.specialBatch.menuSpecialBatch
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.specialBatch
                    .menuSpecialBatchApply
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/special-batch/apply"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Apply</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.specialBatch
                    .menuSpecialBatchApplicationList
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/special-batch/application-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Application List</a
                >
              </li>
            </ul>
          </li>
          <li
            [appRequiredPermission]="
              applicationPermissions.stpOperation.newStpUser.menuPermission
            "
            nz-submenu
            nzIcon="user-switch"
            nzClose
            nzTitle="STP User"
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.newStpUser
                    .menuCreatePermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/new-user/add-user"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Add User
                </a>
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.newStpUser.newStpUserList
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/new-user/stp-user-list"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>User List
                </a>
              </li>
            </ul>
          </li>
          <li nz-menu-item 
              [appRequiredPermission]="
              applicationPermissions.stpOperation.log.trainingManagementActivityLog
              "
              (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/training-management-log">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Training
              Management Log</a
            >
          </li>
        </ul>
      </li>
      <li
        nz-submenu
        nzClose
        nzIcon="history"
        nzTitle="Payment History"
        [appRequiredPermission]="
          applicationPermissions.payment.paymentHistory.menuPaymentHistory
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.payment.paymentHistory
                .menuStpPaymentHistory
            "
          >
            <a routerLink="/home/payment/stp-payment-history"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>STP</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.payment.paymentHistory
                .menuCourseAccreditationPaymentHistory
            "
          >
            <a
              routerLink="/home/payment/course-and-assessment-center-accreditation-payment-history"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Course</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.payment.paymentHistory
                .menuAssessmentPaymentHistory
            "
          >
            <a routerLink="/home/payment/assessment-payment-history"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Assessment</a
            >
          </li>
        </ul>
      </li>
      <li
        nz-submenu
        nzClose
        nzIcon="exception"
        nzTheme="outline"
        nzTitle="Assessment Application"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.asseessmentApplication
            .menuPermission
        "
      >
        <ul>
          <li
            [appRequiredPermission]="
              applicationPermissions.stpOperation.regularAssessment
                .menuPermission
            "
            nz-submenu
            nzClose
            nzIcon="file"
            nzTitle="Regular Assessment"
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.regularAssessment
                    .menuListPermission
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/assessment/assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Assessment List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.regularAssessment
                    .menuRegularCertificatesPending
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/reg/regular-certificates-pending-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Certificates Pending</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.regularAssessment
                    .menuRegularCertificatesIssued
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/reg/regular-certificates-issued-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Certificates Issued</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <ul>
          <li
            [appRequiredPermission]="
              applicationPermissions.stpOperation.rplAssessment.menuPermission
            "
            nz-submenu
            nzClose
            nzIcon="usergroup-add"
            nzTitle="RPL-Batch Assessment"
          >
            <ul
              [appRequiredPermission]="
                applicationPermissions.stpOperation.rplAssessment
                  .menuListPermission
              "
            >
              <li nz-menu-item (click)="nzCollapsed()">
                <a
                  routerLink="/home/stp-operations/rpl/rpl-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Assessment List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplAssessment
                    .menuRplCertificatesPending
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/rpl/rpl-certificates-pending-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Certificates Pending</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.rplAssessment
                    .menuRplCertificatesIssue
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/rpl/rpl-certificates-issued-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Certificates Issued</a
                >
              </li>
            </ul>
          </li>
        </ul>

        <ul>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="user"
            nzTitle="RPL-Individual Assessment"
            [appRequiredPermission]="
              applicationPermissions.applicant.menuPermission
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.paymentSetup.menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/rpl-individual/payment-setup/"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Payment
                  Setup</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.createCircularForm
                    .menuPermission
                "
              >
                <a routerLink="/home/applicant/rpl-individual/create-circular/"
                  ><i nz-icon nzType="form" nzTheme="outline"></i>Create
                  Circular</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.circulaListAdmin
                    .menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/applicant/rpl-individual/circular-list-admin"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Circular List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.circulaList.menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/rpl-individual/circular-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Circular List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.applicantShortList
                    .menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/shortlist"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>List
                  of Application</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant
                    .rplIndividualBatchScheduleLayer1.menuPermission
                "
              >
                <a routerLink="/home/applicant/rpl-individual-batch-create"
                  ><i nz-icon nzType="usergroup-add" nzTheme="outline"></i
                  >Create Batch</a
                >
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.rplIndividualBatchList
                    .menuPermission
                "
              >
                <a routerLink="/home/applicant/rpl-individual-batch-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>Batch
                  List</a
                >
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.applicantList.menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/application-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Application List</a
                >
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.appliedCircularList.menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/rpl-individual/applied-circular-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Applied Circular List</a
                >
              </li>



              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.applicant.archiveCircularList.menuPermission
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/applicant/rpl-individual/archive-circular-list"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Archived Circular List</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <ul>
          <li
            nz-submenu
            nzIcon="split-cells"
            nzClose
            nzIcon="split-cells"
            nzTitle="Re-Assessment"
            [appRequiredPermission]="
              applicationPermissions.stpOperation.specialBatch
                .menuSpecialBatchAdmin
            "
          >
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.specialBatch
                    .menuSpecialBatchApplicationListAdmin
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/special-batch/application-list-admin"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Application List</a
                >
              </li>

              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.specialBatch
                    .menuSbCertificatesPending
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/special-batch/sb-certificates-pending-assessment-app-list-view"
                  ><i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Certificates Pending</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <ul>
          <li>
            <ul>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.asseessmentApplication
                    .menuAssessmentResultAdmin
                "
                (click)="nzCollapsed()"
              >
                <a
                  routerLink="/home/stp-operations/assessment/assessment-result-admin"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Assessment Result
                </a>
              </li>
              <li
                nz-menu-item
                [appRequiredPermission]="
                  applicationPermissions.stpOperation.log.assessmentActivityLog
                "
                (click)="nzCollapsed()"
              >
                <a routerLink="/home/stp-operations/assessment-activity-log">
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Assessment Activity Log
                </a>
              </li>

            </ul>
          </li>
        </ul>
        <!-- <ul>
          <li nz-submenu nzIcon="application" nzClose nzIcon="file" nzTitle="RPL-Individual">
            <ul>
              <li nz-menu-item [appRequiredPermission]="
              applicationPermissions.stpOperation.rplIndividualAssessment.submitRplIndivScheduleAssessment">
                <a routerLink="/home/stp-operations/rpl-individual/schedule-assessment-individual"><i nz-icon
                    nzType="form" nzTheme="outline"></i>Schedule Assessment for RPL-Individual Assessment</a>
              </li>
              <li nz-menu-item [appRequiredPermission]="
              applicationPermissions.stpOperation.rplIndividualAssessment.submitRplIndivScheduleAssessment">
                <a routerLink="/home/stp-operations/rpl-individual/application-list"><i nz-icon nzType="form"
                    nzTheme="outline"></i>Application List</a>
              </li>
            </ul>
          </li>
        </ul> -->
      </li>

      <!--      mew-->
      <li
        nz-submenu
        nzClose
        nzIcon="exception"
        nzTheme="outline"
        nzTitle="Assigned Assessment List"
        [appRequiredPermission]="
          applicationPermissions.applicant.representativeAssignedAssessmentList
            .menuPermission
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.applicant
                .rplIndividualRepresentativeAssignedAssessmentList
                .menuPermission
            "
          >
            <a routerLink="/home/applicant/representative/rpl-indv-app-list"
              ><i nz-icon nzType="ordered-list" nzTheme="outline"></i>RPL Individual</a
            >
          </li>
        </ul>
      </li>
      <li
        nz-submenu
        nzClose
        nzIcon="file-search"
        nzTitle="Research & Studies"
        [appRequiredPermission]="
          applicationPermissions.researchAndStudies
            .menuResearchAndStudiesPermission
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies
              .menuAddResearchAndStudiesPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/research-and-studies/add">
              <i nz-icon nzType="form" nzTheme="outline"></i>Add</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies
              .menuListResearchAndStudiesAdminPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/research-and-studies/list-nsda">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >List-NSDA</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies
              .menuListExternalUsersPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/research-and-studies/list-external-users">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Document
              List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies.menuListIscUsersPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/research-and-studies/list-isc-users">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Document
              List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies
              .menuExternalUserRegFormFunctionPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/research-and-studies/external-user-reg-form-manager"
            >
              <i nz-icon nzType="form" nzTheme="outline"></i>Manage
              Registration</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.researchAndStudies.log
              .rsActivityLogPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/research-and-studies/rs-activity-log">
              <i nz-icon nzType="audit" nzTheme="outline"></i>Activity Log</a
            >
          </li>
        </ul>
      </li>
      <li
        [appRequiredPermission]="
          applicationPermissions.stpOperation.assessor
            .menuAssignedAssessmentList
        "
        nz-submenu
        nzClose
        nzIcon="file"
        nzTitle="Assigned
        Assessment List"
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor
              .menuRegularAssignedAssessmentList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/stp-operations/assessor/regular-assigned-assessment-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Regular-Batch</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.applicant.rplIndividualAssignedAssessmentList
          .menuPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/applicant/rpl-indiv-assigned-assessment-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>RPL
              Individual</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor
              .menuRplAssignedAssessmentList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/stp-operations/assessor/assigned-assessment-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >RPL-Batch</a
            >
          </li>
        </ul>

        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.specialBatch
              .menuSpecialBatchAssignedAssessmentList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/stp-operations/special-batch/sb-assigned-assessment-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i
              >Re-Assessment</a
            >
          </li>
        </ul>
      </li>

      <!-- <li
        nz-submenu
        nzIcon="rollback"
        nzClose
        nzTitle="Rollback"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.rollback.menuPermission
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.rollback.rollbackStatus
              .menuPermission
          "
        >
          <li nz-menu-item>
            <a routerLink="/home/rollback/rollback-status"
              ><i nz-icon nzType="form" nzTheme="outline"></i>Rollback Status</a
            >
          </li>
        </ul>
      </li> -->

      <li
        nz-submenu
        nzClose
        nzIcon="monitor"
        nzTheme="outline"
        nzTitle="NAP"
        [appRequiredPermission]="
          applicationPermissions.nap.menuNapDashboard +
          ',' +
          applicationPermissions.nap.menuNapCreateAgency +
          ',' +
          applicationPermissions.nap.menuNapAgencyUserList +
          ',' +
          applicationPermissions.nap.menuNapTargetReview +
          ',' +
          applicationPermissions.nap.menuTrainingTargetReview +
          ',' +
          applicationPermissions.nap.menuNapReportReview +
          ',' +
          applicationPermissions.nap.menuTrainingReportReview +
          ',' +
          applicationPermissions.nap.menuNapTargetAdjReview +
          ',' +
          applicationPermissions.nap.menuTrainingTargetAdjReview
        "
      >
        <ul
          [appRequiredPermission]="applicationPermissions.nap.menuNapDashboard"
          nz-menu-item
          nzTitle="Dashboard"
          routerLink="/home/national-action-plan/nap-admin-dashboard"
        >
          <i nz-icon nzType="profile" nzTheme="outline"></i
          >Dashboard
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.nap.menuNapCreateAgency +
            ',' +
            applicationPermissions.nap.menuNapAgencyUserList
          "
          nz-submenu
          nzClose
          nzIcon="user-switch"
          nzTitle="Agency Users"
        >
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.nap.menuNapCreateAgency
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/national-action-plan/agency-user/create-agency-user"
            >
              <i nz-icon nzType="form" nzTheme="outline"></i>Create Agency
              User</a
            >
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.nap.menuNapAgencyUserList
            "
            (click)="nzCollapsed()"
          >
            <a
              routerLink="/home/national-action-plan/agency-user/agency-user-list"
            >
              <i nz-icon nzType="form" nzTheme="outline"></i>Agency User List</a
            >
          </li>
        </ul>

        <ul
          nz-submenu
          nzClose
          nzIcon="project"
          nzTitle="Review"
          [appRequiredPermission]="
            applicationPermissions.nap.menuNapTargetReview +
            ',' +
            applicationPermissions.nap.menuTrainingTargetReview +
            ',' +
            applicationPermissions.nap.menuNapReportReview +
            ',' +
            applicationPermissions.nap.menuTrainingReportReview +
            ',' +
            applicationPermissions.nap.menuNapTargetAdjReview +
            ',' +
            applicationPermissions.nap.menuTrainingTargetAdjReview
          "
        >
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuNapTargetReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-nap-target"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>NAP
                Target Review</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuTrainingTargetReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-training-target"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Training
                Target Review</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuNapReportReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-nap-report"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>NAP
                Report Review</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuTrainingReportReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-training-report"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Training
                Report Review</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuNapTargetAdjReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-adjustment-nap-target"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Nap
                Target Adj. Review</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.nap.menuTrainingTargetAdjReview
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a
                routerLink="/home/national-action-plan/reports/review-adjustment-training-target"
              >
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Training
                Target Adj. Review</a
              >
            </li>
          </ul>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="flag"
        nzTheme="outline"
        nzTitle="Policies & Guidelines"
        [appRequiredPermission]="
          applicationPermissions.policiesAndGuidelines.menuAddDocument +
          ',' +
          applicationPermissions.policiesAndGuidelines.menuDocumentListNsda +
          ',' +
          applicationPermissions.policiesAndGuidelines.menuArchivedList
        "
      >
        <ul>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="file"
            nzTitle="Documents"
            [appRequiredPermission]="
              applicationPermissions.policiesAndGuidelines.menuAddDocument +
              ',' +
              applicationPermissions.policiesAndGuidelines.menuDocumentListNsda
            "
          >
            <ul
              [appRequiredPermission]="
                applicationPermissions.policiesAndGuidelines.menuAddDocument
              "
            >
              <li nz-menu-item (click)="nzCollapsed()">
                <a
                  routerLink="/home/policy-guidelines/documents/document-create"
                >
                  <i nz-icon nzType="form" nzTheme="outline"></i>Add Document
                </a>
              </li>
            </ul>
            <ul
              [appRequiredPermission]="
                applicationPermissions.policiesAndGuidelines
                  .menuDocumentListNsda
              "
            >
              <li nz-menu-item (click)="nzCollapsed()">
                <a
                  routerLink="/home/policy-guidelines/documents/document-list-nsda"
                >
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Document List</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <ul>
          <li
            nz-submenu
            nzIcon="application"
            nzClose
            nzIcon="file"
            nzTitle="Archived"
            [appRequiredPermission]="
              applicationPermissions.policiesAndGuidelines.menuArchivedList
            "
          >
            <ul>
              <li nz-menu-item (click)="nzCollapsed()">
                <a routerLink="/home/policy-guidelines/archived/archived-list">
                  <i nz-icon nzType="ordered-list" nzTheme="outline"></i
                  >Archived List</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="setting"
        nzTheme="outline"
        nzTitle="Settings"
        [appRequiredPermission]="
          applicationPermissions.settings.ministry.menuCreatePermission +
          ',' +
          applicationPermissions.settings.ministry.menuListPermission +
          ',' +
          applicationPermissions.settings.agency.menuCreatePermission +
          ',' +
          applicationPermissions.settings.agency.menuListPermission
        "
      >
        <ul
          nz-submenu
          nzClose
          nzIcon="project"
          nzTitle="Ministry"
          [appRequiredPermission]="
            applicationPermissions.settings.ministry.menuCreatePermission +
            ',' +
            applicationPermissions.settings.ministry.menuListPermission
          "
        >
          <ul
            [appRequiredPermission]="
              applicationPermissions.settings.ministry.menuCreatePermission
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a routerLink="/home/stp-registration/add-ministry">
                <i nz-icon nzType="form" nzTheme="outline"></i>Add Ministry</a
              >
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.settings.ministry.menuListPermission
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a routerLink="/home/stp-registration/ministry-list">
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Ministry
                List</a
              >
            </li>
          </ul>
        </ul>
        <ul
          nz-submenu
          nzClose
          nzIcon="user-switch"
          nzTitle="Agency"
          [appRequiredPermission]="
            applicationPermissions.settings.agency.menuCreatePermission +
            ',' +
            applicationPermissions.settings.agency.menuListPermission
          "
        >
          <ul
            [appRequiredPermission]="
              applicationPermissions.settings.agency.menuCreatePermission
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a routerLink="/home/stp-registration/add-agency">
                <i nz-icon nzType="form" nzTheme="outline"></i>Add Agency
              </a>
            </li>
          </ul>
          <ul
            [appRequiredPermission]="
              applicationPermissions.settings.agency.menuListPermission
            "
          >
            <li nz-menu-item (click)="nzCollapsed()">
              <a routerLink="/home/stp-registration/agency-list">
                <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Agency
                List</a
              >
            </li>
          </ul>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="bell"
        nzTheme="outline"
        nzTitle="Event"
        [appRequiredPermission]="
          applicationPermissions.event.menuEventScheduleCreate +
          ',' +
          applicationPermissions.event.menuEventListDashboard
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.event.menuEventScheduleCreate
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/event/add-new-event">
              <i nz-icon nzType="plus" nzTheme="outline"></i>Schedule New
              Event</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.event.menuEventListDashboard
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/event/user-dashboard">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>Event
              List Dashboard</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="profile"
        nzTitle="Assessor Pool"
        [appRequiredPermission]="
          applicationPermissions.stpOperation.assessor.menuAssessorAccessView +
          ',' +
          applicationPermissions.stpOperation.assessor.menuEntryAssessorPool +
          ',' +
          applicationPermissions.stpOperation.assessor
            .menuAssessorApplicationListNsda +
          ',' +
          applicationPermissions.stpOperation.assessor.menuNsdaAssessorPool +
          ',' +
          applicationPermissions.settings.addAssessor.menuAddAssessor
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor
              .menuAssessorFullProfileView
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/assessor-full-profile-view">
              <i nz-icon nzType="user" nzTheme="outline"></i>Full Profile
              View</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.assessorPool.assessorFullProfileAssessor
              .menuPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/assessor-pool/assessor-full-profile-correction-list-assessor"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Profile
              Correction Application
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor.menuAssessorAccessView
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/access-view">
              <i nz-icon nzType="form" nzTheme="outline"></i>Assessor Access
              View</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor.menuEntryAssessorPool
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/apply-assessor-pool">
              <i nz-icon nzType="form" nzTheme="outline"></i>Entry Assessor
              Pool</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.assessorPool.assessorFullProfile
              .menuPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/assessor-pool/assessor-full-profile-correction-list-admin"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Profile
              Correction Application
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor
              .menuAssessorApplicationListNsda
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/nsda-application-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Application
              List
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.stpOperation.assessor.menuNsdaAssessorPool
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/nsda-assessor-pool">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Approved
              Assessors
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.settings.addAssessor.menuAddAssessor
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/assessor-pool/add-assessor">
              <i nz-icon nzType="user" nzTheme="outline"></i>Add Assessor</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.assessorPool.resourcePerson.menuResourcePersonList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/assessor-pool/resource-person-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Resource Person List</a
            >
          </li>
        </ul>

        <ul
          [appRequiredPermission]="
            applicationPermissions.settings.addAssessor.menuAddAssessor
          "
        >
          <li nz-menu-item>
            <a routerLink="/home/stp-operations/assessor-activity-log">
              <i nz-icon nzType="user" nzTheme="outline"></i>Assessor Activity
              Log</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="dollar"
        nzTitle="Financing"
        [appRequiredPermission]="
          applicationPermissions.financialApplication.menuFinancing
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuCreateCircular
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/create-circular">
              <i nz-icon nzType="form" nzTheme="outline"></i>Create Circular</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuFinancialCircularListAdmin
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/circular-list">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>Circular
              List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuCircularListStp
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/circular-list-stp">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>Circular
              List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuApplicationListStp
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/application-list-stp">
              <i nz-icon nzType="form" nzTheme="outline"></i>Application List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuApplicationListAdmin
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/application-list-admin">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i
              >Application List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuApplicationListNhrdf
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/application-list-nhrdf">
              <i nz-icon nzType="form" nzTheme="outline"></i>Application List
              (NHRDF)</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuResolution
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/resolution-process">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i
              >Resolution
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.financialApplication.menuResolutionList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/financial/resolution-list">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i
              >Resolution List
            </a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="dollar"
        nzTitle="Certificate Correction"
        [appRequiredPermission]="
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionApplication +
          ',' +
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionRepresentativeList +
          ',' +
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionScrutinyList +
          ',' +
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionMemberList +
          ',' +
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionECList +
          ',' +
          applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionList
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionApplication
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction-application">
              <i nz-icon nzType="form" nzTheme="outline"></i>Correction Application List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionRepresentativeList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction-application-nsda-rep-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Correction Representative List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionScrutinyList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction-scrutiny-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Correction Scrutiny List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionMemberList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction-member-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Correction Member List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionECList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction-ec-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Correction EC List</a
            >
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.certificateCorrectionForm.menuCertificateCorrectionList
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/stp-operations/certificate-correction/list">
              <i nz-icon nzType="unordered-list" nzTheme="outline"></i>Correction Application</a
            >
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="schedule"
        nzTheme="outline"
        nzTitle="Industry Skills Council"
        [appRequiredPermission]="
          applicationPermissions.isc.menuCreateIscPermission +
          ',' +
          applicationPermissions.isc.menuNsdaIscListPermission +
          ',' +
          applicationPermissions.isc.menuRepresentativeIscPermission +
          ',' +
          applicationPermissions.isc.menuRepresentativeIscListPermission
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.isc.menuCreateIscPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/industry-skills-council/create-isc">
              <i nz-icon nzType="form" nzTheme="outline"></i>Create ISC
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.isc.menuNsdaIscListPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/industry-skills-council/nsda-isc-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>ISC List
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.isc.menuRepresentativeIscPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/industry-skills-council/representative-isc">
              <i nz-icon nzType="form" nzTheme="outline"></i>Representative ISC
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.isc.menuRepresentativeIscListPermission
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              routerLink="/home/industry-skills-council/representative-isc-list"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>ISC List
            </a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="schedule"
        nzTheme="outline"
        nzTitle="MRA/MOU"
        [appRequiredPermission]="applicationPermissions.mra.mraMenuPermission"
      >
        <ul>
          <li
            [appRequiredPermission]="
              applicationPermissions.mra.mraAgreementTypeAddPermission
            "
            (click)="nzCollapsed()"
            nz-menu-item
          >
            <a routerLink="/home/mra/create-agreement-type">
              <i nz-icon nzType="form" nzTheme="outline"></i>Add Agreement Type
            </a>
          </li>
          <li
            [appRequiredPermission]="
              applicationPermissions.mra.menuAddCountryPermission
            "
            (click)="nzCollapsed()"
            nz-menu-item
          >
            <a routerLink="/home/mra/create-country">
              <i nz-icon nzType="form" nzTheme="outline"></i>Add Country
            </a>
          </li>
          <li
            [appRequiredPermission]="
              applicationPermissions.mra.menuCreateMraPermission
            "
            (click)="nzCollapsed()"
            nz-menu-item
          >
            <a routerLink="/home/mra/create-mra-mou">
              <i nz-icon nzType="form" nzTheme="outline"></i>Create MRA/MoU
            </a>
          </li>
          <li
            [appRequiredPermission]="
              applicationPermissions.mra.menuMraListPermission
            "
            (click)="nzCollapsed()"
            nz-menu-item
          >
            <a routerLink="/home/mra/mra-list-admin">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>MRA/MOU
              List
            </a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="schedule"
        nzTheme="outline"
        nzTitle="Program & Project"
        [appRequiredPermission]="
          applicationPermissions.programAndProjects.menuProjectEnlistmentForm +
          ',' +
          applicationPermissions.programAndProjects.menuProjectEnlistmentList +
          ',' +
          applicationPermissions.programAndProjects.menuMonthlyReportList +
          ',' +
          applicationPermissions.programAndProjects.menuProjectCompletionReportList +
          ',' +
          applicationPermissions.programAndProjects.menuProjectEnlistmentListAdmin +
          ',' +
          applicationPermissions.programAndProjects.menuMonthlyReportListAdmin +
          ',' +
          applicationPermissions.programAndProjects.menuProjectCompletionReportAdminList +
          ',' +
          applicationPermissions.programAndProjects.menuProgramAndProjectActivityLog
        "
      >
        <ul>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProjectEnlistmentForm" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/create-project-enlistment">
              <i nz-icon nzType="form" nzTheme="outline"></i>Project Enlistment Form
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProjectEnlistmentList" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/project-enlistment-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Project Enlistment List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProjectEnlistmentListAdmin" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/project-enlistment-list-admin">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Project Enlistment List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuMonthlyReportList" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/monthly-report-list">
              <i nz-icon nzType="form" nzTheme="outline"></i>Monthly Report List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuMonthlyReportListAdmin" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/monthly-report-list-admin">
              <i nz-icon nzType="form" nzTheme="outline"></i>Monthly Report List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProjectCompletionReportList" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/project-completion-report-list">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Project Completion List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProjectCompletionReportAdminList" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/project-completion-report-list-admin">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Project Completion List
            </a>
          </li>
          <li [appRequiredPermission]="applicationPermissions.programAndProjects.menuProgramAndProjectActivityLog" nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/program-project-activity-log">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Activity Log
            </a>
          </li>
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/monitoring-enlistment">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Monitoring
              Enlistment
            </a>
          </li>
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/monitoring-report">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Monitoring
              Monthly Report
            </a>
          </li>
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/program-project/monitoring-completion">
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Monitoring
              Completion
            </a>
          </li>
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="schedule"
        nzTheme="outline"
        nzTitle="Inspection"
        [appRequiredPermission]="
          applicationPermissions.evolutionForm.menuEvolutionForm
        "
      >
        <ul>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.evolutionForm.menuStpEvolutionForm
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="/home/evolution-form/stp-evolution-form">
              <i nz-icon nzType="form" nzTheme="outline"></i>STP Evolution Form
            </a>
          </li>
          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.evolutionForm.menuTrainerEvolutionForm
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="">
              <i nz-icon nzType="form" nzTheme="outline"></i>Trainer Evolution
              Form
            </a>
          </li>

          <li
            nz-menu-item
            [appRequiredPermission]="
              applicationPermissions.evolutionForm.menuTraineeEvolutionForm
            "
            (click)="nzCollapsed()"
          >
            <a routerLink="">
              <i nz-icon nzType="form" nzTheme="outline"></i>Trainee Evolution
              Form
            </a>
          </li>

          <!--          <li nz-menu-item [appRequiredPermission]="-->
          <!--          applicationPermissions.evolutionForm.menuStpEvolutionForm-->
          <!--        ">-->
          <!--            <a routerLink="/home/evolution-form/stp-list-inspection">-->
          <!--              <i nz-icon nzType="form" nzTheme="outline"></i>STP List-->
          <!--            </a>-->
          <!--          </li>-->

          <!--          <li nz-menu-item [appRequiredPermission]="-->
          <!--          applicationPermissions.evolutionForm.menuStpEvolutionForm-->
          <!--        ">-->
          <!--            <a routerLink="/home/evolution-form/stp-inspection-scrutiny">-->
          <!--              <i nz-icon nzType="form" nzTheme="outline"></i>Drafted STP List-->
          <!--            </a>-->
          <!--          </li>-->

          <!--          <li nz-menu-item [appRequiredPermission]="-->
          <!--          applicationPermissions.evolutionForm.menuStpEvolutionForm">-->
          <!--            <a routerLink="/home/evolution-form/stp-inspec-schedule-member">-->
          <!--              <i nz-icon nzType="form" nzTheme="outline"></i>Member Approval-->
          <!--            </a>-->
          <!--          </li>-->

          <!--          <li nz-menu-item [appRequiredPermission]="-->
          <!--          applicationPermissions.evolutionForm.menuStpEvolutionForm">-->
          <!--            <a routerLink="/home/evolution-form/stp-inspec-schedule-ec">-->
          <!--              <i nz-icon nzType="form" nzTheme="outline"></i>EC Approval-->
          <!--            </a>-->
          <!--          </li>-->

          <!--          <li nz-menu-item [appRequiredPermission]="-->
          <!--          applicationPermissions.evolutionForm.menuStpEvolutionForm">-->
          <!--            <a routerLink="/home/evolution-form/feedback-stp-head">-->
          <!--              <i nz-icon nzType="form" nzTheme="outline"></i>Feebback Form for STP Head-->
          <!--            </a>-->
          <!--          </li>-->
        </ul>
      </li>

      <li
        nz-submenu
        nzClose
        nzIcon="solution"
        nzTitle="Reports"
        [appRequiredPermission]="
          applicationPermissions.reports.menuReportPermission
        "
      >
        <ul
          [appRequiredPermission]="
            applicationPermissions.reports.menuPaymentCollection
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              href="https://skillsportal.gov.bd/metabase/public/dashboard/307bf373-501a-44ef-9a0d-587f1f269170"
              target="_blank"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Payment
              Collection
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="
            applicationPermissions.reports.menuIssuedCertificates
          "
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              href="https://skillsportal.gov.bd/metabase/public/dashboard/ef48d15e-945e-42de-ac91-12204d5eecf0"
              target="_blank"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>Issued
              Certificates
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="applicationPermissions.reports.menuStpInfo"
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a
              href="https://skillsportal.gov.bd/metabase/public/dashboard/d40a117c-3cb9-48b8-8c63-607928f1c68d"
              target="_blank"
            >
              <i nz-icon nzType="ordered-list" nzTheme="outline"></i>STP Info
            </a>
          </li>
        </ul>
        <ul
          [appRequiredPermission]="applicationPermissions.emailLog.menuPermission"
        >
          <li nz-menu-item (click)="nzCollapsed()">
            <a routerLink="/home/email-log">
              <i nz-icon nzType="mail" nzTheme="outline"></i>Email Delivery Log
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger">
          <button
            type="button"
            class="header-menu-button"
            title="Toggle menu"
            (click)="isCollapsed = !isCollapsed"
          >
            <i
              class="trigger"
              nz-icon
              [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"
            ></i>
          </button>


          <b class="stpName" *ngIf="registrationNumber">{{ stpName }}</b>
        </span>




        <ul
          class="mr-10 header-action-list"
          nz-menu
          nzMode="horizontal"
        >
          <li *ngIf="registrationNumber" class="registration-number-item">
            <span class="registration-number-text">
              <span class="registration-number-label">Registration Number : </span>
              <b>{{ registrationNumber }}</b>
            </span>
          </li>

          <!--notification -->
          <li [hidden]="!notificationData" class="notification-trigger-item">
            <button
              nz-button
              nzType="default"
              class="notification-trigger-button"
              title="Notifications"
              (click)="onBellOpen(true)"
            >
              <nz-badge class="header-notification-badge" [nzCount]="notificationData?.totalUnread" [nzOverflowCount]="99">
                <img src="assets/img/notification.png" alt="bell" class="custom-bell" />
              </nz-badge>
            </button>
          </li>
          <!--  notification -->

          <!-- <li class="nav-item">-->
          <li class="nav-item profile-trigger-item">
            <a class="nav-link btn btn-outline-custom profile-trigger-link" nz-dropdown [nzDropdownMenu]="imgprofile">
              <img
                [src]="imageUrl || defaultProfileImageUrl"
                class="profile-trigger-image"
                [class.profile-default-image]="imageUrl === defaultProfileImageUrl"
                alt="profile"
                (error)="onProfileImageError($event)"
              >
            </a>
            <nz-dropdown-menu #imgprofile="nzDropdownMenu" nzDropdownTrigger="click">
              <ul nz-menu nzSelectable>
                <li nz-menu-item (click)="onChangePassword()" (click)="nzCollapsed()">
                  <i nz-icon nzType="setting" nzTheme="outline"></i>Change Password
                </li>
                <li nz-menu-item (click)="userProfile()" (click)="nzCollapsed()">
                  <i nz-icon nzType="user" nzTheme="outline"></i>Profile
                </li>
                <li nz-menu-item (click)="onLogout()" (click)="nzCollapsed()">
                  <i nz-icon nzType="logout" nzTheme="outline"></i>Logout
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>

        </ul>
      </div>
    </nz-header>
    <nz-content style="margin: 10px">
      <div class="inner-content">
        <nz-alert
          *ngIf="showStpExpiredBanner"
          nzType="error"
          nzShowIcon
          [nzMessage]="
            stpExpiryStatus?.reason === 'EXPIRED'
              ? 'STP Registration Expired'
              : 'STP Registration Not Active'
          "
          [nzDescription]="stpExpiredDescription"
          class="mb-2 d-block"
        ></nz-alert>
        <ng-template #stpExpiredDescription>
          {{ stpExpiryService.getMessage(stpExpiryStatus) }}
          Creating new projects, courses, batches, trainees, trainers, STP users,
          assessment applications and payments is blocked until the registration
          is renewed. Work already in progress can still be completed.
          <a style="cursor: pointer" (click)="onStpRenew()">Renew / Reapply</a>
        </ng-template>
        <nz-alert
          *ngIf="showStpExpiringWarning"
          nzType="warning"
          nzShowIcon
          nzCloseable
          nzMessage="STP Registration Expiring Soon"
          [nzDescription]="stpExpiringDescription"
          class="mb-2 d-block"
        ></nz-alert>
        <ng-template #stpExpiringDescription>
          Your STP registration expires
          {{
            stpExpiryStatus?.expiresInDays === 0
              ? 'today'
              : 'in ' + stpExpiryStatus?.expiresInDays + ' day(s)'
          }}
          ({{ stpExpiryService.formatDate(stpExpiryStatus?.expireDate) }}).
          Renew before it expires to avoid interruption.
          <a style="cursor: pointer" (click)="onStpRenew()">Renew / Reapply</a>
        </ng-template>
        <router-outlet></router-outlet>
      </div>
    </nz-content>
    <!-- <nz-footer>Synesis It ©2021 </nz-footer> -->
    <app-footer></app-footer>
  </nz-layout>
</nz-layout>
<nz-drawer
  [nzVisible]="isNotificationOpen"
  nzTitle="Notifications"
  nzPlacement="right"
  [nzWidth]="380"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  (nzOnClose)="onBellOpen(false)"
>
  <ng-container *nzDrawerContent>
    <div class="notification-drawer-summary">
      <span>Total unread</span>
      <strong>{{ notificationData?.totalUnread || 0 }}</strong>
    </div>

    <div
      class="notification-module-list"
      *ngIf="notificationData?.moduleUnreadCounts?.length; else emptyNotificationModules"
    >
      <button
        nz-button
        nzType="default"
        *ngFor="let module of notificationData.moduleUnreadCounts; trackBy: trackByNotificationModule"
        class="notification-module-button"
        [class.active]="module.moduleId === selectedNotificationModuleId"
        (click)="loadNotificationsForModule(module.moduleId, module.moduleName)"
      >
        <span>{{ module.moduleName }}</span>
        <nz-badge [nzCount]="module.unreadCount" [nzOverflowCount]="99"></nz-badge>
      </button>
    </div>

    <div class="notification-drawer-body">
      <div class="notification-drawer-header" *ngIf="selectedNotificationModuleName">
        <h4>{{ selectedNotificationModuleName }}</h4>
        <a
          *ngIf="selectedNotificationModuleId"
          (click)="goToModule(selectedNotificationModuleId); onBellOpen(false)"
        >
          Open full list
        </a>
      </div>

      <nz-spin [nzSpinning]="notificationListLoading">
        <div
          class="notification-card"
          *ngFor="let notification of notificationItems; trackBy: trackByNotificationItem"
          [class.notification-card-link]="!!notification.url"
          [title]="notification.url ? 'Open' : ''"
          (click)="openNotification(notification)"
        >
          <div class="notification-card-header">
            <strong>{{ notification.title || notification.moduleName || 'Notification' }}</strong>
            <span [class.read]="notification.isRead">
              {{ notification.isRead ? 'Read' : 'Unread' }}
            </span>
          </div>
          <p>{{ notification.message }}</p>
          <div class="notification-card-footer">
            <small>{{ notification.createdAt | date: 'medium' }}</small>
            <button
              *ngIf="!notification.isRead"
              nz-button
              nzType="link"
              nzSize="small"
              class="notification-mark-read-btn"
              (click)="markDrawerNotificationAsRead(notification, $event)"
            >
              Mark as read
            </button>
          </div>
        </div>

        <nz-empty
          *ngIf="!notificationListLoading && !notificationItems.length"
          nzNotFoundContent="No notifications available"
        ></nz-empty>
      </nz-spin>
    </div>
  </ng-container>
</nz-drawer>

<ng-template #emptyNotificationModules>
  <nz-empty nzNotFoundContent="No unread notifications"></nz-empty>
</ng-template>
<nz-modal
  [(nzVisible)]="isCertificateModalVisible"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1000"
>
  <nz-card>
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="safety-certificate" nzTheme="outline"></i> Cautions!!
    </div>
    <h6 style="color: red">
      **Use latest version of Adobe Reader to see certificates properly
      (সার্টিফিকেট সঠিকভাবে দেখতে Adobe Reader এর সর্বশেষ সংস্করণ ব্যবহার করুন)
    </h6>
    <div *nzModalFooter>
      <button nz-button nzType="primary" (click)="handleCancel()">
        Cancel
      </button>
      <button nz-button nzType="primary" (click)="handleOk()">Download</button>
    </div>
  </nz-card>
</nz-modal>
